import React,{useCallback,useContext,useState} from 'react'
import *  as config from '../../../next.config.js'
// import { Header } from '../../../components/components/Layout/Header'
// import DownloadApp from '../../../components/components/Home/DownloadApp'
// import SquareFooter from '../../../components/components/Layout/SquareFooter'
// import Footer from '../../../components/components/Layout/Footer'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
// import { useRouter } from 'next/router'
import AllBlog from '../../../components/components/Blog/AllBlog'
import SiteSeo from '../../../components/components/seo/SiteSeo'
import { useTranslation } from 'next-i18next'
// import KeyWordsHelper from "../../../components/components/KeyWords/KeyWordsHelper"
import KeyWordsData from '../../../components/components/KeyWords/KeyWords'
import buildQueryForKeywordsFunction from '../../api/cms/keywords/buildQueryForKeywordsFunction'
// import { getvocabTermsObj } from "../../api/globals/terms/helpers";
import AllDetails from '../../../components/components/Blog/AllDetails'
import getSlugFunction from "../../api/cms/slug/getSlugFunction";
import getIncludeStatusIdsFromBack from '../../api/globals/terms/getIncludeStatusIdsFromBack'
import getBlogFunction from '../../api/cms/blog/getBlogFunction'
import NotFound from '../../../components/components/NotFound'
import TermsContext from "../../../context/Trems"
import { printLogs,stripeHTMLTags } from '../../../components/helpers/helpers';
import Statistics from "../../../components/components/Statistics";
import { useRouter } from "next/router";
// import { printLogs } from '../../../components/helpers/helpers'
// import Link from 'next/link'
export default function Blog(props) {
  const router = useRouter()
  const { t } = useTranslation("common")
  // const router = useRouter()
  const [post ,setPost]=useState([])
  let title 
  let meta = [
    {
      name: "description",
      content:t("hakeemStartWithMetaDescription")+" "+ t("blogPageMetaDescription"),
    }
  ]

 if(props.params.type=="articles"){
  title =t("Articals")
 }
 else if(props.params.type=="medical-advices"){
  title = t("MedicalAdvices")
 }
 else if (props.params.type=="news"){
  title= t("News")
 }else{
  t("Articals")
 }

 const callback = useCallback(
  back => {
    setPost(back)
  },
  []
);
if(props.blogData&&JSON.parse(props.blogData).data.length > 0){
  
  meta = [
   {
     name: "description",
     content:stripeHTMLTags(props.blogData&&JSON.parse(props.blogData).data[0].transBlog[0].body).substr(0, 1000),
      image: post.image !=null ?post.image:config.basePath+"/assest/defaultBlogImage.svg",
      url:config.env.baseUrl+router.asPath
   }
 ];
}
const vocabTerms= useContext(TermsContext)
  return (
    <div>


      {["medical-advices","news","articles"].includes(props.params.type)?<><SiteSeo title={title} meta={meta} />
      <KeyWordsData keyWords={JSON.parse(props.keyWords)}/>
      <AllBlog blogType={props.params.type} /></>:""}

      {!["medical-advices","news","articles"].includes(props.params.type)?
      props.blogData&&JSON.parse(props.blogData).data.length > 0 ?<>
        <SiteSeo title={JSON.parse(props.blogData).data[0].transBlog[0].title } meta={meta}/>
        <KeyWordsData keyWords={JSON.parse(props.keyWords)}/>
        <Statistics entityId={JSON.parse(props.blogData).data[0].entityDetailsId}   statisticsCode={"blog"}/>
      <AllDetails
          entityId={JSON.parse(props.blogData).data[0].entityDetailsId}
          blogType={JSON.parse(props.blogData).data[0].blogTypes[0].code}
          callback={callback}
          blogDetails={JSON.parse(props.blogData).data}
         /></>:  <NotFound number={props.slugResult&&JSON.parse(props.slugResult).length>0?'404':'410'}/>:""}
    </div>
  )
}
export async function getServerSideProps({ locale, params,req,res }) {

  let dataOfQuery={}
  let getKeywords=null
  let slugResult=null
  let blogData=null
  if(["medical-advices","news","articles"].includes(params.type)){
    dataOfQuery.langCode=locale
    dataOfQuery.slugEntityClass=["blog"]
    dataOfQuery.slugEntityClassType=[params.type]
     getKeywords=await buildQueryForKeywordsFunction(dataOfQuery,req)
  }
  else{
    let slugData= {}
    let entityId 
    let slugId=[]

    if(params.type){
  
     slugData.url=JSON.stringify([params.type])
     slugData.lang=locale

     if(/\d+/g.test(params.type)){
      entityId=[params.type]
    }else{
       slugResult = await getSlugFunction(slugData, req);
      if(slugResult.length>0){
      
        entityId =[slugResult[0].entityId]
        slugId=slugResult[0].id
      }
    }

  
  }
  
  let dataOfQuery={}
  if(entityId){
  if(slugId){
    dataOfQuery.slugId=[slugId]
  }
  dataOfQuery.langCode=locale
  dataOfQuery.slugEntityClass=["blog"]

  let blogParams={}

    blogParams.id=JSON.stringify(entityId)
    blogParams.langId=locale
  let Statuscodes = {
    vocabCode: [
      "maker-checker-entity-status",
      "maker-checker-status",
      "maker-only-status"
    ]
  };
  let StatusIds = await getIncludeStatusIdsFromBack(Statuscodes, req);
  blogParams.getBlogSlug= ""
  blogParams.statusId=JSON.stringify(StatusIds)

   blogData = await getBlogFunction(blogParams,req)
   if(blogData.data.length>0){
    dataOfQuery.slugEntityClassType=[blogData.data[0].blogTypes[0].code]
    getKeywords=await buildQueryForKeywordsFunction(dataOfQuery,req)
   }
   
}

  }
  if((slugResult!=null&&blogData==null)||(slugResult!=null&&blogData!=null&&blogData.data.length==0)){
    res.statusCode=410
  }
// console.log("slugResult============>",slugResult,blogData)
 
  return {
    props: {
      blogData:blogData?JSON.stringify(blogData):null,
      slugResult:slugResult?JSON.stringify(slugResult):null,
      keyWords:getKeywords?JSON.stringify(getKeywords.content):null,
      params,
      ...(await serverSideTranslations(locale, ["common"])),

    }
  }
};
